export function getWindowLocation() {
  return window.location;
}
export function getMarketingEmbedNavLocale(lang) {
  switch (lang) {
    case 'pt':
      return 'pt_BR';
    case 'zh-cn':
      return 'zh_CN';
    case 'zh':
    case 'zh-tw':
      return 'zh_TW';
    default:
      return lang;
  }
}